import axios from 'axios'
import { Message } from 'element-ui'
import { notifyUnauthorized } from './auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000
})

service.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response && error.response.status
    if (status === 401) {
      notifyUnauthorized()
    } else if (status === 500) {
      Message.error('服务器错误，请稍后重试')
    } else if (error.response && error.response.data && error.response.data.msg) {
      Message.error(error.response.data.msg)
    } else if (error.message && error.message.includes('timeout')) {
      Message.error('请求超时，请稍后重试')
    } else if (!error.response) {
      Message.error('网络异常，请稍后重试')
    }
    return Promise.reject(error)
  }
)

export default service
